import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  orgDataService,
  reportsDataService,
  ssDialogService,
  vmDataService,
  vmSharedModelService,
} from 'app/services';
import {
  documentManagement,
  datePicker,
} from 'app/components/global';
import productName from './product-name.directive';
import editContactDialog from '../dialog.editContactDialog';
import editSOCCommentDialog from '../dialog.editSOCCommentDialog';
import editInsuranceCommentDialog from '../dialog.editInsuranceCommentDialog';
import confirmBeginRiskAssessmentDialog from '../product/dialog.confirmBeginRiskAssessmentDialog';
import controller from './edit-product-dialog.controller';
import template from './edit-product-dialog.html';
import validator, { name as validatorName } from './unique-product-name.validator.directive';
import productNameMessagesTpl from './messages/product.name.messages.html';
import productLastAssessmentDateMessagesTpl from './messages/product.last-assessment-date.messages.html';
import productLastReviewDateMessagesTpl from './messages/product.last-review-date.messages.html';
import productFinancialTermMessagesTpl from './messages/product.financial-term.messages.html';
import productContractAmountMessagesTpl from './messages/product.contract-amount.messages.html';
import productAutoRenewMessagesTpl from './messages/product.auto-renew.messages.html';
import productAlertThresholdMessagesTpl from './messages/product.alert-threshold.messages.html';
import productAlertMessagesTpl from './messages/product.alert.messages.html';

const ngCurrency = 'ng-currency';
require('ng-currency/dist/ng-currency');

class dialogService {
  getOptions($event, {
    masterVendorId, product, vendor, addCallback,
  }) {
    return {
      controller,
      controllerAs: 'editProductDialogVM',
      locals: {
        masterVendorId,
        product,
        vendor, // only use for passing to risk assessment dialog
        addCallback,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editProductDialog', [
  ngCurrency,
  constants,
  loaderService,
  orgDataService,
  reportsDataService,
  ssDialogService,
  vmDataService,
  vmSharedModelService,
  editContactDialog,
  editSOCCommentDialog,
  editInsuranceCommentDialog,
  confirmBeginRiskAssessmentDialog,
  documentManagement,
  datePicker,
])
  .directive(validatorName, validator)
  .directive('vmProductName', productName)
  .service('editProductDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('product.name.messages.html', productNameMessagesTpl);
    $templateCache.put('product.last-assessment-date.messages.html', productLastAssessmentDateMessagesTpl);
    $templateCache.put('product.last-review-date.messages.html', productLastReviewDateMessagesTpl);
    $templateCache.put('product.financial-term.messages.html', productFinancialTermMessagesTpl);
    $templateCache.put('product.contract-amount.messages.html', productContractAmountMessagesTpl);
    $templateCache.put('product.auto-renew.messages.html', productAutoRenewMessagesTpl);
    $templateCache.put('product.alert-threshold.messages.html', productAlertThresholdMessagesTpl);
    $templateCache.put('product.alert.messages.html', productAlertMessagesTpl);
  })
  .name;
